import React from "react"
import { Link } from "react-router-dom"

const ReportsLink = () => ( 
  <div className="menu-button">
    <Link className="reports" to="/reports">Reports</Link>
  </div>
)

export default ReportsLink